export default __webpack_public_path__ + "static/hero-09093a3635da9cff261ba7f09e7383db.jpg";